const MuiBackdrop = {
  root: {
    backdropFilter: 'blur(3px)',
    '-webkit-backdrop-filter': 'blur(3px)'
  },
  invisible: {
    backdropFilter: 'unset',
    '-webkit-backdrop-filter': 'unset'
  }
};
export default MuiBackdrop;